import { SignalKindsToInclude } from '../../../constants/SignalsKinds';
/**
 * check whether integral based on its kind can be included in another operation or not
 * @param integral  integral
 * @returns {boolean}
 */
export function checkIntegralKind(integral) {
    return SignalKindsToInclude.includes(integral.kind);
}
//# sourceMappingURL=checkIntegralKind.js.map